/*undefined*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.QuoteTemplateFilter = (function() {

    /**
     * Namespace QuoteTemplateFilter.
     * @exports QuoteTemplateFilter
     * @namespace
     */
    var QuoteTemplateFilter = {};

    QuoteTemplateFilter.QuoteTemplateFilterModel = (function() {

        /**
         * Properties of a QuoteTemplateFilterModel.
         * @memberof QuoteTemplateFilter
         * @interface IQuoteTemplateFilterModel
         * @property {string|null} [name] QuoteTemplateFilterModel name
         * @property {string|null} [sortColumn] QuoteTemplateFilterModel sortColumn
         * @property {string|null} [sortOrder] QuoteTemplateFilterModel sortOrder
         * @property {number|null} [pageIndex] QuoteTemplateFilterModel pageIndex
         * @property {number|null} [pageSize] QuoteTemplateFilterModel pageSize
         * @property {Array.<string>|null} [tagIDs] QuoteTemplateFilterModel tagIDs
         */

        /**
         * Constructs a new QuoteTemplateFilterModel.
         * @memberof QuoteTemplateFilter
         * @classdesc Represents a QuoteTemplateFilterModel.
         * @implements IQuoteTemplateFilterModel
         * @constructor
         * @param {QuoteTemplateFilter.IQuoteTemplateFilterModel=} [p] Properties to set
         */
        function QuoteTemplateFilterModel(p) {
            this.tagIDs = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * QuoteTemplateFilterModel name.
         * @member {string|null|undefined} name
         * @memberof QuoteTemplateFilter.QuoteTemplateFilterModel
         * @instance
         */
        QuoteTemplateFilterModel.prototype.name = null;

        /**
         * QuoteTemplateFilterModel sortColumn.
         * @member {string|null|undefined} sortColumn
         * @memberof QuoteTemplateFilter.QuoteTemplateFilterModel
         * @instance
         */
        QuoteTemplateFilterModel.prototype.sortColumn = null;

        /**
         * QuoteTemplateFilterModel sortOrder.
         * @member {string|null|undefined} sortOrder
         * @memberof QuoteTemplateFilter.QuoteTemplateFilterModel
         * @instance
         */
        QuoteTemplateFilterModel.prototype.sortOrder = null;

        /**
         * QuoteTemplateFilterModel pageIndex.
         * @member {number|null|undefined} pageIndex
         * @memberof QuoteTemplateFilter.QuoteTemplateFilterModel
         * @instance
         */
        QuoteTemplateFilterModel.prototype.pageIndex = null;

        /**
         * QuoteTemplateFilterModel pageSize.
         * @member {number|null|undefined} pageSize
         * @memberof QuoteTemplateFilter.QuoteTemplateFilterModel
         * @instance
         */
        QuoteTemplateFilterModel.prototype.pageSize = null;

        /**
         * QuoteTemplateFilterModel tagIDs.
         * @member {Array.<string>} tagIDs
         * @memberof QuoteTemplateFilter.QuoteTemplateFilterModel
         * @instance
         */
        QuoteTemplateFilterModel.prototype.tagIDs = $util.emptyArray;

        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;

        /**
         * QuoteTemplateFilterModel _name.
         * @member {"name"|undefined} _name
         * @memberof QuoteTemplateFilter.QuoteTemplateFilterModel
         * @instance
         */
        Object.defineProperty(QuoteTemplateFilterModel.prototype, "_name", {
            get: $util.oneOfGetter($oneOfFields = ["name"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * QuoteTemplateFilterModel _sortColumn.
         * @member {"sortColumn"|undefined} _sortColumn
         * @memberof QuoteTemplateFilter.QuoteTemplateFilterModel
         * @instance
         */
        Object.defineProperty(QuoteTemplateFilterModel.prototype, "_sortColumn", {
            get: $util.oneOfGetter($oneOfFields = ["sortColumn"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * QuoteTemplateFilterModel _sortOrder.
         * @member {"sortOrder"|undefined} _sortOrder
         * @memberof QuoteTemplateFilter.QuoteTemplateFilterModel
         * @instance
         */
        Object.defineProperty(QuoteTemplateFilterModel.prototype, "_sortOrder", {
            get: $util.oneOfGetter($oneOfFields = ["sortOrder"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * QuoteTemplateFilterModel _pageIndex.
         * @member {"pageIndex"|undefined} _pageIndex
         * @memberof QuoteTemplateFilter.QuoteTemplateFilterModel
         * @instance
         */
        Object.defineProperty(QuoteTemplateFilterModel.prototype, "_pageIndex", {
            get: $util.oneOfGetter($oneOfFields = ["pageIndex"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * QuoteTemplateFilterModel _pageSize.
         * @member {"pageSize"|undefined} _pageSize
         * @memberof QuoteTemplateFilter.QuoteTemplateFilterModel
         * @instance
         */
        Object.defineProperty(QuoteTemplateFilterModel.prototype, "_pageSize", {
            get: $util.oneOfGetter($oneOfFields = ["pageSize"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Encodes the specified QuoteTemplateFilterModel message. Does not implicitly {@link QuoteTemplateFilter.QuoteTemplateFilterModel.verify|verify} messages.
         * @function encode
         * @memberof QuoteTemplateFilter.QuoteTemplateFilterModel
         * @static
         * @param {QuoteTemplateFilter.IQuoteTemplateFilterModel} m QuoteTemplateFilterModel message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        QuoteTemplateFilterModel.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(10).string(m.name);
            if (m.sortColumn != null && Object.hasOwnProperty.call(m, "sortColumn"))
                w.uint32(18).string(m.sortColumn);
            if (m.sortOrder != null && Object.hasOwnProperty.call(m, "sortOrder"))
                w.uint32(26).string(m.sortOrder);
            if (m.pageIndex != null && Object.hasOwnProperty.call(m, "pageIndex"))
                w.uint32(32).int32(m.pageIndex);
            if (m.pageSize != null && Object.hasOwnProperty.call(m, "pageSize"))
                w.uint32(40).int32(m.pageSize);
            if (m.tagIDs != null && m.tagIDs.length) {
                for (var i = 0; i < m.tagIDs.length; ++i)
                    w.uint32(50).string(m.tagIDs[i]);
            }
            return w;
        };

        /**
         * Encodes the specified QuoteTemplateFilterModel message, length delimited. Does not implicitly {@link QuoteTemplateFilter.QuoteTemplateFilterModel.verify|verify} messages.
         * @function encodeDelimited
         * @memberof QuoteTemplateFilter.QuoteTemplateFilterModel
         * @static
         * @param {QuoteTemplateFilter.IQuoteTemplateFilterModel} message QuoteTemplateFilterModel message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        QuoteTemplateFilterModel.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a QuoteTemplateFilterModel message from the specified reader or buffer.
         * @function decode
         * @memberof QuoteTemplateFilter.QuoteTemplateFilterModel
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {QuoteTemplateFilter.QuoteTemplateFilterModel} QuoteTemplateFilterModel
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        QuoteTemplateFilterModel.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.QuoteTemplateFilter.QuoteTemplateFilterModel();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.name = r.string();
                    break;
                case 2:
                    m.sortColumn = r.string();
                    break;
                case 3:
                    m.sortOrder = r.string();
                    break;
                case 4:
                    m.pageIndex = r.int32();
                    break;
                case 5:
                    m.pageSize = r.int32();
                    break;
                case 6:
                    if (!(m.tagIDs && m.tagIDs.length))
                        m.tagIDs = [];
                    m.tagIDs.push(r.string());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        /**
         * Decodes a QuoteTemplateFilterModel message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof QuoteTemplateFilter.QuoteTemplateFilterModel
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {QuoteTemplateFilter.QuoteTemplateFilterModel} QuoteTemplateFilterModel
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        QuoteTemplateFilterModel.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        return QuoteTemplateFilterModel;
    })();

    return QuoteTemplateFilter;
})();

module.exports = $root;
